var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pricing-content" }, [
    _c("div", { staticClass: "pricing-info" }, [
      _vm.duration
        ? _c("div", { staticClass: "pricing" }, [
            _c("div", [
              _c("span", [
                _c("span", { staticClass: "pink" }, [
                  _vm._v(_vm._s(_vm.duration))
                ]),
                _vm._v(" HORAS DE LIMPEZA\n        ")
              ]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "transition",
                    { attrs: { name: "fade", mode: "in-out" } },
                    [
                      _vm.pricingWithDiscount
                        ? _c("span", { staticClass: "original-pricing" }, [
                            _vm._v(
                              "\n                de " +
                                _vm._s(_vm._f("toCurrency")(_vm.pricing)) +
                                "\n              "
                            )
                          ])
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "pink" }, [
                    _vm._v(
                      "POR " +
                        _vm._s(
                          _vm._f("toCurrency")(
                            _vm.pricingWithDiscount || _vm.pricing
                          )
                        )
                    )
                  ])
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v("Transporte e alimentação do profissional inclusos.")
            ])
          ])
        : _c("span", { staticClass: "pricing-alert" }, [
            _vm._v("\n      É necessário definir a "),
            _c("b", [_vm._v("duração")]),
            _vm._v(" da limpeza para calcularmos o "),
            _c("b", [_vm._v("valor")]),
            _vm._v(".\n    ")
          ])
    ]),
    _vm._v(" "),
    !_vm.canPayWithBoleto
      ? _c("div", { staticClass: "payment-type" }, [
          _vm._v(
            "\n    O dia selecionado permite pagamento apenas via cartão de crédito. Para pagamento via boleto selecione um dia à partir de "
          ),
          _c("span", [_vm._v(_vm._s(_vm.labelDaysToPay))]),
          _vm._v(".\n  ")
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-318fcc98", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-318fcc98","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PurchaseFlow/Components/Scheduler/Steps/Pricing/Index.vue
// module id = null
// module chunks = 